import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

// @ts-ignore
const windowResources = window.resources;
i18n
  .use(initReactI18next)
  .use(HttpApi)
  .init({
    resources: windowResources,
    initImmediate: false,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    },
    debug: true,
    supportedLngs: ['en', 'ar'],
    react: {
      wait: true
    }
  });

export default i18n;
